import { createSlice } from '@reduxjs/toolkit';
import { getBusinessProjectsList } from './businessProjects.thunk';
import { BusinessProjectInitialState } from 'models/interfaces/businessProjects.interface';

const initialState: BusinessProjectInitialState = {
  businessProjects: null,
  loading: false,
  error: null,
};

const projectsSlice = createSlice({
  name: 'businessProjects',
  initialState,
  reducers: {},
  extraReducers: {
    [getBusinessProjectsList.pending.toString()]: state => {
      state.businessProjects = null;
      state.loading = true;
      state.error = null;
    },
    [getBusinessProjectsList.fulfilled.toString()]: (state, { payload }) => {
      state.businessProjects = payload.items;
      state.loading = false;
    },
    [getBusinessProjectsList.rejected.toString()]: (state, { payload }) => {
      state.error = payload;
      state.loading = false;
    },
  },
});

export default projectsSlice.reducer;
